import { render, staticRenderFns } from "./english-big-free-base.vue?vue&type=template&id=714531fc&scoped=true&"
import script from "./english-big-free-base.vue?vue&type=script&lang=js&"
export * from "./english-big-free-base.vue?vue&type=script&lang=js&"
import style0 from "./english-big-free-base.vue?vue&type=style&index=0&id=714531fc&lang=scss&scoped=true&"
import style1 from "./english-big-free-base.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714531fc",
  null
  
)

export default component.exports